const betterPrivacyPolicyPersonalInformation = [
  {
    title: 'Personal Identifiers',
    examples:
      'Name, alias, address, Social Security number, date of birth, passport number, unique personal identifier, on-line identifier, IP address, e-mail address, account name, government issued identification number, phone number, signature',
  },
  {
    title: 'Personal Characteristics',
    examples:
      'Gender, demographic, medical and health, convictions, marital status, offspring, driving record, family member/other status, and other descriptions of your physical characteristics',
  },
  {
    title: 'Commercial Information',
    examples:
      'Personal property, insurance policy number, medical information, or health insurance information, purchased products or services, considered products or services, purchasing or consuming histories or tendencies',
  },
  {
    title: 'Biometric Information',
    examples: 'Voice print, photo.',
  },
  {
    title: 'Internet or Network Activity',
    examples:
      'Information regarding your interactions with websites, applications, and advertisements, browser type, electronic communications, IP address, cookies.',
  },
  {
    title: 'Geolocation',
    examples:
      'IP address, physical address, telephone number, state, municipality, location, devices, applications on mobile and computer devices',
  },
  {
    title: 'Audio, Electronic, Visual, Thermal, Olfactory',
    examples:
      'Audio, electronic, photo, visual information, such as a call or video recording, voicemail messages.',
  },
  {
    title: 'Professional Information and Employment Information',
    examples:
      'Job titles, work history, school(s) attended, employment status, veteran, or military status ',
  },
  {
    title: 'Education Information',
    examples:
      'Job titles, work history, school attended, marital and family status, e-mail, telephone recordings ',
  },
  {
    title: 'Inferences',
    examples:
      'Preferences, behaviors, characteristics, trends, predispositions, attitudes, abilities, and aptitudes.',
  },
  {
    title: 'Sensitive Personal Information',
    examples:
      'Social Security number, driver’s license number, state ID card, account log-in, precise geo-location, bank account number, credit or debit card number, or any other financial information, trade union membership, your communications with us.',
  },
] as const;

export default betterPrivacyPolicyPersonalInformation;
